@if (loading) {
  <app-shimmer-loader
    [appearance]="loaderAppearance"
    [count]="1"
    [theme]="loaderTheme"
    class="loader"
    />
}
<img
  (error)="url && handleError()"
  (load)="hideLoader()"
  [class.hidden]="loading"
  [src]="url"
  class="image"
  [alt]=alt
  >
